import { useSelector } from 'react-redux';

import { selectCarouselHydrated, selectCarouselItems, selectConfiguration } from './ducks/we-spin-selectors';
import Carousel from '~/components/carousel/carousel';
import { enhanceCampaignImageFactory } from '~/components/utilities/image-format';

const WeSpinSessionLobbyCarousel = () => {
	const carouselItems = useSelector(selectCarouselItems);
	const carouselHydrated = useSelector(selectCarouselHydrated);
	const { imageFormats, campaignBackgroundImageDescriptors, campaignForegroundImageDescriptors } =
		useSelector(selectConfiguration);

	const enhanceCampaignImage = enhanceCampaignImageFactory(
		imageFormats,
		campaignBackgroundImageDescriptors,
		campaignForegroundImageDescriptors
	);

	const items = carouselItems.map(banner => ({
		...banner,
		backgroundImage: enhanceCampaignImage(banner.backgroundImage, 'background'),
		foregroundImage1: banner.foregroundImage1
			? enhanceCampaignImage(banner.foregroundImage1, 'foreground')
			: undefined,
		foregroundImage2: banner.foregroundImage2
			? enhanceCampaignImage(banner.foregroundImage2, 'foreground')
			: undefined,
		tcImage: banner.tcImage ? enhanceCampaignImage(banner.tcImage, 'foreground') : undefined
	}));

	return carouselItems && carouselItems.length > 0 && <Carousel campaigns={items} isHydrated={carouselHydrated} />;
};

export default WeSpinSessionLobbyCarousel;
